import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/copyVersion', params).then((response) => response.data);
};

export const useMutationCopyVersion = () => {
    return useMutation<unknown, QueryError, QueryParams>({ mutationFn: (params) => mutationFn(params) });
};

interface QueryParams {
    metaDataId: number;
    contractId: number;
    projectId: number;
    versionName: string;
}
